import React, {useContext, useEffect} from 'react'
import {Languages} from "./Home"
import "../styles/manifesto.scss"

export default function Manifesto() {
    const lang = useContext(Languages)
    const posizionePartenza = -300
    const dimensioni = [400, 400, 400, 400, 400, 400 ,400 ,400, 400, 400, 400, 400, 400, 400 ,400 ,400, 400]

    useEffect(()=>{
        setTimeout(()=>{
            window.scrollTo({
                top: 0,
                behavior: 'instant' // Questo crea uno scorrimento fluido
              });   
        }, 0)
        
    }, [])

    return (
        <>
        <div className='manifesto_section max-w' id="manifesto" data-aos="zoom-out-up" data-aos-duration="1000">
            <h1 className='titolo'>{lang['MANIFESTO']}</h1>
                <h3 className='titolo_sezione'>{lang["PERCHÉ L’ENNESIMA AGENZIA?"]}</h3>
            <div className='container_manifesto_testo'>
                {/*<p className='testo_generico'>
                    {lang["Perché quando eravamo noi i clienti, non abbiamo trovato nelle agenzie"]}<br/>
                    {lang["Vogliamo essere l'agenzia che avremmo voluto trovare quando serviva a noi."]}
                </p>
                <p className='testo_generico'>
                    {lang["Non ti scriveremo cosa facciamo"]} <br/>
                    {lang["Ti riassumeremo però le cose che assolutamente NON facciamo"]}
                </p>*/}
                <p className='testo_generico'>
                    <br />
                <b>Blend nasce dall'insoddisfazione. <br />
                        Quella che abbiamo provato quando i clienti eravamo noi. </b><br /><br /><br />
                        
                        Abbiamo avuto con le agenzie immobiliari esperienze non sempre gradevoli, fatte di spiegazioni approssimative, scarsa chiarezza delle procedure e tanta cavillosa burocrazia.<br /> 
                        Le sorprese sono belle al compleanno, non quando stai per spendere tanti soldi per comprare una casa.  <br /><br />
                        <b>E così abbiamo creato la nostra agenzia.</b> Blend è l’unione di
                        <b> architetti, tecnici, pubblicitari, agenti immobiliari. </b>Ognuno con i propri anni di esperienza e con la propria competenza specifica, ma con una visione unica e condivisa:
                        <b> noi vogliamo essere l'agenzia che avremmo desiderato, quando ne avevamo bisogno.</b><br />
                        Questa è la nostra missione. Questo è il nostro perché.<br />

                        
                </p>
                <p className='testo_generico'>
                Non ti scriveremo cosa facciamo, perché facciamo esattamente ciò che
                fa un'agenzia immobiliare (o almeno ciò che dovrebbe fare).<br /><br />
                Ti diremo però le cose che assolutamente<br />
                NON FACCIAMO.
                </p>
            </div>
        </div>
        {/*<div className='riquadro_verde_maniefesto riquadro_verde_sezione_manifesto'>
            {dimensioni.map((elem, index) =>{
                return (
                    <div key={index} className={"column column_w c" + index} style={{left: posizionePartenza+(330*index), height: elem}}/>
                )
            })}
        </div>*/}

        <div className='cont_scritte_finali'>
            <div className='max-w'>
                
                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON SIAMO INVADENTI</h3>
                        <p className='testo_generico'>
                        Noi crediamo nella discrezione. Non ti richiamiamo dopo un
                        appuntamento, ci sono già abbastanza call center invadenti.<br  />
                        Se sei interessato, ci richiamerai tu.<br/>
                        <b>Stai comprando una casa, non un gelato.<br/>
                        Se devi pensarci un po', non c'è nulla di strano.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON CI ATTEGGIAMO</h3>
                        <p className='testo_generico'>
                            Non usiamo inglesismi come real estate, broker, agency o advisory per
                            darci un tono importante. Parole straniere o diciture arcaiche le
                            utilizziamo solo quando queste sono strettamente necessarie.<br/>
                            <b>Non è una cosa detta in inglese a fare di noi dei professionisti.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON SIAMO AUTOCELEBRATIVI</h3>
                        <p className='testo_generico'>
                        Non usiamo slogan come “professionalità, competenza e correttezza”
                        per dire che siamo professionali, competenti e corretti.<br/>
                        <b>Un re che deve dire “io sono il re” non è un re.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON CREDIAMO CHE SIA LA CRAVATTA A RENDERCI CREDIBILI</h3>
                        <p className='testo_generico'>
                            Non obblighiamo nessuno dei nostri a indossare un abito e una cravatta.
                            Le capacità non passano dal modo in cui ci vestiamo.<br/>
                            Ciò nonostante, comunque non verremo agli appuntamenti in tuta e
                            ciabatte.<br />
                            <b>Non guardare se usiamo la cravatta, guarda se usiamo il cervello.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON AVRAI NESSUNA PENALE NEL CONTRATTO</h3>
                        <p className='testo_generico'>
                        Potrai andar via quando vuoi. Se ti sei trovato male con noi, è colpa
                        nostra, ed è giusto che tu possa tutelare i tuoi interessi in ogni momento.<br/>
                        <b>Non vogliamo che siano le postille di un contratto a farci guadagnare
                        soldi. Vogliamo guadagnarli se siamo bravi.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON SCRIVIAMO CHE LAVORIAMO DA TANTI ANNI PER
                        SEMBRARE AFFIDABILI</h3>
                        <p className='testo_generico'>
                            Non ti scriveremo che abbiamo 10, 20 o 30 anni di esperienza, anche se
                            potremmo. Se avere 30 anni di lavoro fosse garanzia di qualità, allora
                            tutti i 50enni del mondo sarebbero professionisti impeccabili.<br />
                            <b>Eppure siamo certi che chiunque avrebbe qualche dubbio su questo.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON SUPERVALUTIAMO</h3>
                        <p className='testo_generico'>
                        Non spariamo valori altissimi e fuori mercato nella valutazione di casa
                        tua per attirare la tua attenzione e per convincerti a darla a noi da
                        vendere.<br/>
                        <b>Fare i fenomeni all'inizio e per poi portarti zero risultati, non ci interessa.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON TI ABBANDONIAMO ALLE TUE ANSIE</h3>
                        <p className='testo_generico'>
                            Comprare casa dovrebbe essere un piacere, non uno stress. Siamo
                            sempre a disposizione per placare i tuoi dubbi e le tue angosce.<br />
                            Sia perché è la nostra etica, sia perché se sarai soddisfatto di noi,
                            diventerai la nostra migliore pubblicità.<br />
                            <b>A volte la gente ha bisogno che la propria fiducia venga ricompensata.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON TI DIREMO CHE METTIAMO IL CLIENTE AL PRIMO POSTO</h3>
                        <p className='testo_generico'>
                        Perchè, c'è qualcuno che non lo fa? E non ti diremo nemmeno che
                        siamo un team di professionisti che garantisce un servizio a 360 gradi, o
                        quelle cose lì che trovi scritte ovunque (è chiaro che tutti vorremmo un
                        servizio impeccabile da parte di un professionista).<br/>
                        <b>Non ci piace la retorica, sarai tu a valutare se offriamo un servizio
                        all'altezza delle aspettative.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON ABBIAMO IL POSTER DELLA FAMIGLIA FELICE DIETRO LA
                        SCRIVANIA</h3>
                        <p className='testo_generico'>
                        Vorremmo andare oltre al marketing elementare secondo cui casa
                        significa famiglia. Può essere che vendi perchè tua moglie ti ha lasciato
                        o compri perchè vuoi avere un’entrata extra per pagarti le prossime
                        vacanze a Formentera.<br />
                            <b>E se vuoi comprare ma hai il mutuo cointestato con la tua ex, risolviamo
                            pure quello.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON SCRIVIAMO LE STESSE COSE SU TUTTI GLI ANNUNCI</h3>
                        <p className='testo_generico'>
                        Sugli annunci leggiamo sempre “in zona servitissima” “finiture di pregio”
                        “doppia esposizione” “a due passi da…” “ottimo per investimento” etc…<br/>
                        Non ci piace descrivere le case tutte allo stesso modo. Ognuna ha pregi
                        e difetti, che cercheremo di raccontare in modo concreto.<br />
                        <b>Punteremo a descrizioni che abbiano più anima e meno formalità.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON CI IMPROVVISIAMO, LO FACCIAMO DI LAVORO</h3>
                        <p className='testo_generico'>
                        Quando stai male chiami il medico e non vai su internet a farti le
                        diagnosi da solo. Quando ti si rompe la macchina vai dal meccanico e
                        non la aggiusti da solo. Applica lo stesso criterio con la casa.<br />
                        <b>Non venderla da solo, affidati a chi lo fa di lavoro e conosce la materia.
                        Tipo noi, per esempio.</b>
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>NON COMPLICHIAMO I PROCESSI</h3>
                        <p className='testo_generico'>
                        L'immobiliare è un mondo in cui convivono la materia fiscale e quella
                        giuridica, che spesso appaiono contorte e poco chiare. Noi ti
                        semplificheremo i concetti complessi, in modo che tu abbia
                        perfettamente chiara ogni situazione.<br/>
                        <b>Quando capisci una cosa difficile, diventa facile.</b>
                        </p>
                    </div>
                </div>


                {/*<div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>{lang["NON COMPLICHIAMO I PROCESSI"]}</h3>
                        <p className='testo_generico'>
                            {lang["L'immobiliare è un mondo in cui convivono"]}<br/>
                            {lang["Quando capisci una cosa difficile, diventa facile."]}
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>{lang["NON SIAMO INVADENTI"]}</h3>
                        <p className='testo_generico'>
                            {lang["Noi crediamo nella discrezione."]}<br/>
                            {lang["Stai comprando una casa, non un gelato"]}
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-left" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>{lang["NON TI ABBANDONIAMO ALLE TUE ANSIE"]}</h3>
                        <p className='testo_generico'>
                            {lang["Comprare casa dovrebbe essere un piacere"]}<br/>
                            {lang["A volte la gente ha bisogno che la propria fiducia venga ricompensata."]}
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' >
                    <div className='elem_inside' data-aos="fade-right" data-aos-duration="1000">
                        <h3 className='titolo_sezione'>{lang["NON CI ATTEGGIAMO"]}</h3>
                        <p className='testo_generico'>
                            {lang["Non usiamo inglesismi come real estate"]}<br/>
                            {lang["Non è una cosa detta in inglese a fare di me un professionista."]}
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' data-aos="fade-left" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON ABBIAMO IL POSTER DELLA FAMIGLIA FELICE"]}</h3>
                        <p className='testo_generico'>
                            {lang["Vorremmo andare oltre al marketing elementare"]}<br/>
                            {lang["E se vuoi comprare ma hai il mutuo cointestato"]}
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' data-aos="fade-right" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON SIAMO AUTOCELEBRATIVI"]}</h3>
                        <p className='testo_generico'>
                            {lang["Non usiamo slogan come professionalità"]}<br/>
                            {lang["Un re che deve dire"]}
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' data-aos="fade-left" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON CREDIAMO CHE SIA LA CRAVATTA A RENDERCI CREDIBILI"]}</h3>
                        <p className='testo_generico'>
                            {lang["Non obblighiamo nessuno dei nostri"]}<br/>
                            {lang["Non guardare se usiamo la cravatta, guarda se usiamo il cervello."]}
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' data-aos="fade-right" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON AVRAI NESSUNA PENALE NEL CONTRATTO"]}</h3>
                        <p className='testo_generico'>
                            {lang["Potrai andar via quando vuoi"]}<br/>
                            {lang["Non vogliamo che siano le postille"]}
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' data-aos="fade-left" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON SCRIVIAMO LE STESSE COSE SU TUTTI GLI ANNUNCI"]}</h3>
                        <p className='testo_generico'>
                            {lang["Non ci piace descrivere le case tutte allo stesso modo"]}<br/>
                            {lang["“In zona servitissima”"]}
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' data-aos="fade-right" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON ABBIAMO UN SECONDO LAVORO"]}</h3>
                        <p className='testo_generico'>
                            {lang["Se anche tu quando stai male chiami il medico"]}<br/><br/>
                            {lang["Tipo noi, per esempio."]}
                        </p>
                    </div>
                </div>

                <div className='elem_destro_scritte_finali' data-aos="fade-left" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON SUPERVALUTIAMO"]}</h3>
                        <p className='testo_generico'>
                            {lang["Non spariamo valori altissimi"]}<br/>
                            {lang["Fare i fenomeni all'inizio"]}
                        </p>
                    </div>
                </div>

                <div className='elem_sinistro_scritte_finali' data-aos="fade-right" data-aos-duration="1000">
                    <div className='elem_inside'>
                        <h3 className='titolo_sezione'>{lang["NON TI DIREMO CHE METTIAMO IL CLIENTE AL PRIMO POSTO"]}</h3>
                        <p className='testo_generico'>
                            {lang["Perchè, c'è qualcuno che non lo fa?"]}<br/>
                            {lang["Non ci piace la retorica"]}
                        </p>
                    </div>
    </div>*/}

            </div>
        </div>
        </>
    )
}
